/** Preload HubSpot forms v2.js once — shared by all embeds on the page. */
export function preloadHubSpotForms() {
  if (typeof document === 'undefined') return;
  if (window.hbspt) return;
  if (document.querySelector('script[src*="js.hsforms.net/forms/v2.js"]')) return;

  if (!document.querySelector('link[href="https://js.hsforms.net"]')) {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = 'https://js.hsforms.net';
    document.head.appendChild(link);
  }

  const s = document.createElement('script');
  s.src = 'https://js.hsforms.net/forms/v2.js';
  s.async = true;
  document.head.appendChild(s);
}
